module.exports = __webpack_public_path__ + "img/non-real_icon.0ff85874.png";